import React from "react";
import { MobileScreenSettingsShortcuts } from "@/types/mobile-settings";
import { getShortcutIcon } from "./shortcutIcons";

interface ShortcutItemProps {
  shortcut: MobileScreenSettingsShortcuts;
}

export const ShortcutItem: React.FC<ShortcutItemProps> = ({ shortcut }) => {
  const Icon = getShortcutIcon(shortcut.iconId, shortcut.name);

  return (
    <div className="flex max-w-[220px] min-w-[120px] items-center gap-2 rounded-md border border-zinc-200 bg-zinc-100 px-4 py-2">
      <Icon className="size-4 shrink-0 text-zinc-500" />
      <span className="truncate text-sm font-medium" title={shortcut.name}>
        {shortcut.name}
      </span>
    </div>
  );
};
